@if (active()) {
  <div class="loading-container" data-cy="appLoadingSpinnerContent">
    @if (isProgressBar()) {
      <div class="box" style="padding: 0px 0px" border-radius="3px">
        <section class="card-progress">
          <div class="card-progress--title">
            <div aria-hidden="true" class="card-progress__icons">
              <i class="afi-icon">
                <img src="./assets/images/ui/Icon_puzzle.svg" />
              </i>
              <i class="afi-icon">
                <img src="./assets/images/ui/Icon_Car.svg" />
              </i>
              <i class="afi-icon">
                <img src="./assets/images/ui/Icon_Keys.svg" />
              </i>
              <i class="afi-icon">
                <img src="./assets/images/ui/Icon_Discounts.svg" />
              </i>
            </div>
            <div class="card-progress--title__headline">
              <div dsContent [contentPath]="'shared.autoQuoteCalculation'"></div>
              <div dsContent [contentPath]="'shared.loadingMessage'"></div>
            </div>
          </div>
          <div style="border: none">
            <progress max="100" [value]="progress()" class="progress"></progress>
            <p>{{ progress() }}%</p>
          </div>
        </section>
      </div>
    } @else if (isNewLoader()) {
      <div>
        <div class="box" [ngStyle]="{ 'max-width.px': maxWidth() }">
          <img
            class="car-icon"
            src="./assets/images/vehicle/auto-icon-loader.svg"
            alt="loader car icon"
          />
          <div class="spinner-afi">
            <div class="spin-accent"></div>
            <div class="center"></div>
          </div>
          <div
            class="heading-main"
            [innerHTML]="loadingMessage()"
            dsContent
            [contentPath]="'shared.loadingStatus'"
          ></div>
          @if (secondaryMessage().length > 0) {
            <div>
              <hr aria-hidden="true" class="fill" />
              <span [innerHTML]="secondaryMessage()"></span>
            </div>
          }
        </div>
      </div>
    } @else {
      <div
        class="spinner-large spinner-border spinner-primary"
        [ngStyle]="{ 'max-width.px': maxWidth() }"
      >
        <div class="progress-track">
          <div class="progress-bar"></div>
        </div>
        @if (loadingMessage()) {
          <div class="custom-loading-message" [innerHTML]="loadingMessage()"></div>
        }
        @if (secondaryMessage().length > 0) {
          <div class="custom-secondary-message">
            <hr aria-hidden="true" class="fill" />
            <span [innerHTML]="secondaryMessage()"></span>
          </div>
        }
      </div>
    }
  </div>
}
